import React from "react";
import styled from "@emotion/styled";
import { Link } from "../Link";

interface IconLinkProps {
  href: string;
  className?: string;
  label: string;
  startSlot?: React.ReactNode;
  endSlot?: React.ReactNode;
}

const CentredLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 16px;
  &:hover {
    opacity: 0.8;
  }
  &:focus-visible {
    outline: 2px solid white;
    outline-offset: 4px;
  }
  color: ${({ theme }) => theme.colors.snowdrop};
`;

export const IconLink = ({
  href,
  label,
  startSlot,
  endSlot,
  className,
}: IconLinkProps) => {
  return (
    <CentredLink className={className} href={href}>
      {startSlot}
      {label}
      {endSlot}
    </CentredLink>
  );
};
